import React from 'react';
import './home.scss'
import About from '../../Organisms/About';
import Contact from '../../Organisms/Contact';
import Profile from '../../Organisms/Profile';
import Portofolio from '../../Organisms/Portofolio';
import Navigation from '../../Templates/Navigation'
import Footer from '../../Templates/Footer';
const Home = () => {
    return (
        <React.Fragment>
            <Navigation/>
            <div className="home-container">
                <Profile/>
                <About/>
                <Portofolio/>
                <Contact/>
            </div>
            <Footer/>
        </React.Fragment>
    );
};

export default Home;